import React, { FC } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import IndicacaoEspecial from 'pages/indicacao-especial/indicacao-especial';
import Historico from 'pages/historico/historico';
import Home from 'pages/home/home';
import Revisao from 'pages/revisao/revisao';
import Detalhes from 'pages/aprovacao-detalhes/';
import ChangePass from 'pages/ChangePass';
import ChangePersonalInfo from 'pages/ChangePersonalInfo';
import AutoApproval from 'pages/AutoApproval';
import FinancialData from 'pages/FinancialData';
import CampanhasMkt from 'pages/campanhas/CampanhasMkt/campanhas-mkt';
import CriarCampanha from 'pages/campanhas/criarCampanha/criarCampanha';
import Login from 'pages/login/login';
import TesteCookie from 'pages/teste-cookie/index';
import SolicitarRecuperacaoSenha from 'pages/login/solicitacao-recuperacao-senha/SolicitacaoRecuperacaoSenha';
import RedefinicaoSenha from 'pages/login/redefinicao-senha/RedefinicaoSenha';
import MenuAngular from 'components/MenuAngular/menu-angular';
import { EnumtypeError, ErrorPage } from '@fundacao/shared-components/esm/ie';
import PrivateRoute from './privateRoute';

const Routes: FC = () => {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route path="/" component={Login} exact />

        <Route path="/login" component={Login} />

        <Route
          path="/solicitar-recuperacao-senha"
          component={SolicitarRecuperacaoSenha}
        />

        <Route path="/redefinir-senha" component={RedefinicaoSenha} />

        <Route path="/trocar-Senha" component={ChangePass} />

        <Route path="/teste-cookie" component={TesteCookie} />

        <PrivateRoute
          path="/indicacao-especial"
          component={IndicacaoEspecial}
        />

        <PrivateRoute path="/home" component={Home} />

        <PrivateRoute
          exact
          path="/aprovacao-automatica"
          component={AutoApproval}
        />

        <PrivateRoute
          path="/aprovacao-automatica/create"
          component={Detalhes}
        />

        <PrivateRoute path="/aprovacao-automatica/edit" component={Detalhes} />

        <PrivateRoute
          path="/indicacao-especial-historico"
          component={Historico}
        />

        <PrivateRoute path="/revisao" component={Revisao} />

        <PrivateRoute path="/perfil" component={ChangePersonalInfo} />

        <PrivateRoute path="/dados-financeiros" component={FinancialData} />

        <PrivateRoute path="/mkt-campanhas" component={CampanhasMkt} />

        <PrivateRoute path="/criar-campanha" component={CriarCampanha} />

        <PrivateRoute path="/menu-ies" component={MenuAngular} />

        <Route
          render={() => <ErrorPage typeError={EnumtypeError.ERROR_404} />}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
